<template>
    <div>
        <vs-popup title="Atualizar Conexão" 
            :button-close-hidden="false" 
            :active.sync="isActive"
            @close="$emit('isActiveFalse')"
            id="create-instance-popup"
        > 
            <div>
                <div>
                    <vs-input label="Nome da Conexão" v-model="instance.name" class="mt-2 w-full" name="tenantName"/>
                    <span class="text-danger text-sm" v-show="errors.has('tenantName')">
                        {{ errors.first('tenantName') }}
                    </span>
                </div>
                <br>

                <div class="align-check-box-update-instance">
                    <div>
                        <div>
                            <vs-checkbox v-model="instance.is_official" size="small">
                                Conexão Oficial
                            </vs-checkbox>
                        </div>
                        
                        <div>
                            <vs-checkbox v-model="instance.unlimitedInstance" size="small">
                                Conexão Ilimitada
                            </vs-checkbox>
                        </div>
                    </div>
    
                    <div>
                        <div>
                            <vs-checkbox :checked="instance.is_official" :disabled="instance.is_official" v-model="instance.reset_finished" size="small">
                                Reset Finalizado
                            </vs-checkbox>
                        </div>
        
                        <div>
                            <vs-checkbox :checked="instance.is_official" :disabled="instance.is_official" v-model="instance.activated" size="small">
                                Conexão Ativa
                            </vs-checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <br>
            <div style="text-align: right;">
                <span>
                    <vs-button size="medium" color="danger" @click="$emit('isActiveFalse')">
                        <span> Cancelar </span>
                    </vs-button>
                </span>
                <span>
                    <vs-button class="ml-4" size="medium" color="success" @click="updateInstanceHttp">
                        <span> Atualizar </span>
                    </vs-button>
                </span>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import instanceHttp from './../../http/requests/connections/index';

    export default {
        name: 'UpdateInstance',
        data() {
            return {
                originalInstance: {}
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            instance: {
                type: Object|Array,
                required: true
            },
            token: {
                type: String,
                required: true
            }
        },
        emits: [
            'isActiveFalse',
            'successfullyUpdated'
        ],
        methods: {
            verify(){
                const permissions = localStorage.getItem('permissions');
                const twoFactor = localStorage.getItem('twoFactor')
                if(!permissions && !twoFactor){
                    this.$router.push('/user-settings')
                }else if(!permissions && twoFactor){
                    this.$router.push('/two-factor')
                }
            },
            async updateInstanceHttp() {
                const data = {
                    ...(
                        this.originalInstance.unlimitedInstance !== this.instance.unlimitedInstance
                        && { unlimitedInstance: this.instance.unlimitedInstance }
                    ),
                    ...(
                        this.originalInstance.isOfficial !== this.instance.is_official
                        && { isOfficial: this.instance.is_official }
                    ),
                    ...(
                        this.originalInstance.resetFinished !== this.instance.reset_finished
                        && { resetFinished: this.instance.reset_finished }
                    ),
                    ...(
                        this.originalInstance.activated !== this.instance.activated
                        && { activated: this.instance.activated }
                    ),
                    ...(
                        this.originalInstance.name !== this.instance.name
                        && { name: this.instance.name }
                    ),
                    tenantName: this.instance.tenantName,
                    id: this.instance.id
                }

                data.isOfficial && (delete data.activated, data.resetFinished);

                if (data.name !== undefined) {
                    const response = await instanceHttp.getAllConnections(data.tenantName, this.token);
                    const hasName = response.data.find(item => item.name === data.name);

                    if (hasName) {
                        return this.$vs.notify({
                            title: 'Erro!',
                            text: 'Uma conexão com esse nome já existe!',
                            color: 'danger'
                        });
                    }
                }

                await instanceHttp.updateInstance(data, this.token)
                .then(response => {
                    this.$vs.notify({
                        title: 'Sucesso!',
                        text: 'Conexão atualizada com sucesso!',
                        color: 'success'
                    });
                    return this.$emit('successfullyUpdated');
                })
                .catch(Exception => {
                    console.log(Exception);
                    return this.$vs.notify({
                        title: 'Erro!',
                        text: 'Algo deu errado ao tentar atualizar a conexão!',
                        color: 'danger'
                    });
                });
            },
            closePopUpUpdate(){
                this.$emit('isActiveFalse');
            },
        },
        computed: {
            parsedUnlimitedInstance() {
                return this.instance.type === 'web_ilimitada'; 
            }
        },
        watch: {
            isActive(active) {
                if (active) {
                    this.instance.unlimitedInstance = this.parsedUnlimitedInstance;

                    Object.assign(this.originalInstance, {
                        unlimitedInstance: this.instance.unlimitedInstance,
                        isOfficial: this.instance.is_official,
                        resetFinished: this.instance.reset_finished,
                        activated: this.instance.activated,
                        name: this.instance.name
                    });
                }
         }
        },
        mounted(){
            this.verify()
        },
        created(){
            this.$events.on('closePopUpUpdate', this.closePopUpUpdate);
        },
        beforeDestroy() {
            this.$events.off('closePopUpUpdate', this.closePopUpUpdate);
        }
    }
</script>

<style lang="scss">
    .align-check-box-update-instance {
        display: flex;
        
        > div:last-of-type {
            margin-left: 30px;
        }
    }
</style>